import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { KoobPageHeader } from '@koob/ui';
import LibraryFilters from '../Library/LibraryFilters';
import { FiltersCard } from '../../../components/Filters';
import LibraryActiveFilters from '../Library/LibraryActiveFilters';
import TripCard from 'components/Trip/TripCard';
import TripList, { buildTripRequestFilters } from 'components/Trip/TripList';
import KoobLayout from '../../../components/Koob/KoobLayout';
import { PER_PAGE_FOR_CATALOG } from '../../../constants';
import { useLibraryFilters } from '@koob/trip-designer';

export default function DistributedTrips() {
  const { t } = useTranslation('tripDesigner');
  const libraryFilters = useLibraryFilters();
  const [total, setTotal] = useState();

  return (
    <KoobLayout
      header={
        <KoobPageHeader
          title={t('pages:dmcTemplates')}
          subtitle={
            total !== undefined && t('dmcTemplates.results', { count: total })
          }
        />
      }
    >
      <FiltersCard bar={<LibraryFilters isDmcTrips />}>
        <LibraryActiveFilters />

        <div className="mt-5">
          <TripList
            perPage={PER_PAGE_FOR_CATALOG}
            filters={buildTripRequestFilters(libraryFilters, {
              type: 'template',
              isDistributedTrip: true,
              // libraryFilters is shared with the library page, and this page
              // hides the author and archive controls: a value set there would
              // silently empty this list (DMC templates have DMC authors, and
              // archived ones are never distributed).
              userId: undefined,
              withArchived: false,
            })}
            onTotalChange={setTotal}
            renderCard={(trip, reload) => (
              <TripCard
                trip={trip}
                reload={reload}
                enableExport
                isDistributedTrip
              />
            )}
          />
        </div>
      </FiltersCard>
    </KoobLayout>
  );
}
